// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reels-page-grid {
  display: grid;
  margin-top: 10px;
  grid-template-areas:  
      "left middle right";
  grid-template-rows: 80px auto;  /* Header + Content */
  grid-template-columns: 250px auto 250px 250px; /* Sidebar - Main - Right Sidebar */
  max-width: 1000vh;
  max-height: 1000vh;
  height: 1000px;
  width: 1550px;
  gap: 15px;
  padding: 10px;
}

/* Right Sidebar */
.reels-left-sidebar-container {
  grid-area: left;
  height: 740px;
  width: 270px;
  border-radius: 20px;
  margin-left: 0px;
  max-height: 740px;
  margin-top: 30px; 
}

.ur-reels-container {
  display: grid;
  grid-template-areas: 
      "top"
      "bottom";
  grid-template-rows: 80px auto;  /* Header + Content */
  grid-template-columns: 250px auto 250px 250px; /* Sidebar - Main - Right Sidebar */
  grid-area: middle;
  max-width: 1000vh;
  height: 720px;
  width: 900px;
  margin-top: 30px;
  margin-left: 15px;
  max-height: 1000vh;
  display: flex;
  flex-direction: column;
  border-radius: 20px;
}

.ur-reels-top-container {
  margin-top: 10px;
  grid-area: top;
  width: 97%;
  min-height: 150px;
  height: 150px;
  border-radius: 10px;
  display: flex;
  flex-direction: row;
  margin-left: 13px;
  box-shadow: 0px 1px 1px darkslategray;
}

/* Middle Section */
.ur-reels-bottom-container {
  grid-area: bottom;
  display: flex;
  background-color: none;
  flex-direction: column;
  gap: 10px;
  width: 97%;
  max-height: 100vh;
  height: 100%;
  margin-left: 13px;
  border-radius: 20px;
  margin-top: 10px;
  overflow: hidden;
} 

.ua-right-sidebar-container {
  grid-area: right;
  height: 720px;
  width: 270px;
  border-radius: 20px;
  margin-left: 0px;
  max-height: 740px;
  margin-top: 40px; 
}

  /* Responsive Design */
  @media (max-width: 900px) {
    .page-grid {
      grid-template-areas:
        "top"
        "middle"
        "left"
        "right";
      grid-template-columns: 1fr;
      grid-template-rows: 80px auto auto auto;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Pages/AccountPage/Components/Reels/UAReelsGridLayout.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB;yBACuB;EACvB,6BAA6B,GAAG,qBAAqB;EACrD,6CAA6C,EAAE,mCAAmC;EAClF,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,SAAS;EACT,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb;;cAEY;EACZ,6BAA6B,GAAG,qBAAqB;EACrD,6CAA6C,EAAE,mCAAmC;EAClF,iBAAiB;EACjB,iBAAiB;EAEjB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;EAEE,sBAAsB;EACtB;IACE;MACE;;;;eAIS;MACT,0BAA0B;MAC1B,uCAAuC;IACzC;EACF","sourcesContent":[".reels-page-grid {\n  display: grid;\n  margin-top: 10px;\n  grid-template-areas:  \n      \"left middle right\";\n  grid-template-rows: 80px auto;  /* Header + Content */\n  grid-template-columns: 250px auto 250px 250px; /* Sidebar - Main - Right Sidebar */\n  max-width: 1000vh;\n  max-height: 1000vh;\n  height: 1000px;\n  width: 1550px;\n  gap: 15px;\n  padding: 10px;\n}\n\n/* Right Sidebar */\n.reels-left-sidebar-container {\n  grid-area: left;\n  height: 740px;\n  width: 270px;\n  border-radius: 20px;\n  margin-left: 0px;\n  max-height: 740px;\n  margin-top: 30px; \n}\n\n.ur-reels-container {\n  display: grid;\n  grid-template-areas: \n      \"top\"\n      \"bottom\";\n  grid-template-rows: 80px auto;  /* Header + Content */\n  grid-template-columns: 250px auto 250px 250px; /* Sidebar - Main - Right Sidebar */\n  grid-area: middle;\n  max-width: 1000vh;\n  max-height: 1000vh;\n  height: 720px;\n  width: 900px;\n  margin-top: 30px;\n  margin-left: 15px;\n  max-height: 1000vh;\n  display: flex;\n  flex-direction: column;\n  border-radius: 20px;\n}\n\n.ur-reels-top-container {\n  margin-top: 10px;\n  grid-area: top;\n  width: 97%;\n  min-height: 150px;\n  height: 150px;\n  border-radius: 10px;\n  display: flex;\n  flex-direction: row;\n  margin-left: 13px;\n  box-shadow: 0px 1px 1px darkslategray;\n}\n\n/* Middle Section */\n.ur-reels-bottom-container {\n  grid-area: bottom;\n  display: flex;\n  background-color: none;\n  flex-direction: column;\n  gap: 10px;\n  width: 97%;\n  max-height: 100vh;\n  height: 100%;\n  margin-left: 13px;\n  border-radius: 20px;\n  margin-top: 10px;\n  overflow: hidden;\n} \n\n.ua-right-sidebar-container {\n  grid-area: right;\n  height: 720px;\n  width: 270px;\n  border-radius: 20px;\n  margin-left: 0px;\n  max-height: 740px;\n  margin-top: 40px; \n}\n\n  /* Responsive Design */\n  @media (max-width: 900px) {\n    .page-grid {\n      grid-template-areas:\n        \"top\"\n        \"middle\"\n        \"left\"\n        \"right\";\n      grid-template-columns: 1fr;\n      grid-template-rows: 80px auto auto auto;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
